<template>
    <div ref="highchartsContainer"></div>
</template>

<script>
import { Vue, Component, Watch } from 'vue-property-decorator';
import Highcharts from 'highcharts';

@Component({
    props: {
        config: {
            type: Object,
            required: true,
        },
    },
})
export default class HighchartsWrapper extends Vue {
    mounted() {
        this.$nextTick(() => {
            this.renderChart();
        });
    }

    renderChart() {
        Highcharts.chart(this.$refs.highchartsContainer, {
            ...this.config.options,
            series: this.config.series,
            xAxis: this.config.xAxis,
            yAxis: this.config.yAxis,
        });
    }

    @Watch('config', { deep: true })
    onConfigChange() {
        this.renderChart();
    }
}
</script>
